import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=7bfa3a9c&scoped=true"
import script from "./InvitationForm.vue?vue&type=script&lang=js"
export * from "./InvitationForm.vue?vue&type=script&lang=js"
import style0 from "./InvitationForm.vue?vue&type=style&index=0&id=7bfa3a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa3a9c",
  null
  
)

export default component.exports